import { ClientStorage, ClientStorageItem } from "../utils/clientstorage";

export const ensureLightMode = () => {
  const colorMode = ClientStorage.fetch(ClientStorageItem.ChakraUIColorMode);
  if (colorMode !== "light") {
    console.trace("setting default color mode");
    console.trace("chakra-ui-color-mode", "light");
    ClientStorage.store(ClientStorageItem.ChakraUIColorMode, "light");
    console.log("light color mode set");
  }
};
